/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PredictiveCampaignAnswerDto } from './PredictiveCampaignAnswerDto';
export type SavePredictiveCampaignDto = {
    icon?: string | null;
    name: string;
    price_id: string;
    product_id: string;
    answers: Array<PredictiveCampaignAnswerDto>;
    setup_step: SavePredictiveCampaignDto.setup_step;
};
export namespace SavePredictiveCampaignDto {
    export enum setup_step {
        DETAILS = 'DETAILS',
        AUDIENCE = 'AUDIENCE',
        INSIGHTS = 'INSIGHTS',
        REVIEW = 'REVIEW',
        FINISHED = 'FINISHED',
    }
}

